import script from "./CommissionListing.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionListing.vue?vue&type=script&setup=true&lang=js"

import "./CommissionListing.vue?vue&type=style&index=0&id=549e82fc&lang=css"

const __exports__ = script;

export default __exports__